import { roofLayoutSource } from "../../utils/roofInitialGrid";

export const isRoofInstallation = (type) => type === "roof_flush" || type === "roof_frame";

// Keep roof positions and site geometry. A NEW framed roof may use the
// calculated row pitch, but never ground parcel tables or their positions.
export function withInstallationLayout(design, type, generatedSpacing, savedSpacing) {
  if (!design || typeof design !== "object") return design;
  if (!isRoofInstallation(type)) {
    return generatedSpacing ? { ...design, spacingInfo: generatedSpacing } : design;
  }
  const { spacingInfo, spacing, ...electrical } = design;
  const manualSpacing = roofLayoutSource(savedSpacing, type);
  const savedPitch = Number(manualSpacing?.minimum_distance_m ?? manualSpacing?.pitch_m ?? manualSpacing?.pitch);
  const hasPlacement = manualSpacing?.module_array || manualSpacing?.manual_layout_edited ||
    manualSpacing?.excluded_slots?.length || Object.keys(manualSpacing?.module_offsets || {}).length;
  if (type === "roof_frame" && !(savedPitch > 0) && !hasPlacement) {
    const pitch = Number(generatedSpacing?.minimum_distance_m ?? generatedSpacing?.pitch_m ??
      generatedSpacing?.minimum_distance ?? generatedSpacing?.pitch);
    const tiers = Number(generatedSpacing?.row_vertical_modules ?? 1);
    // The roof auto-design request uses one module up the slope per row.
    if (Number.isFinite(pitch) && pitch > 0 && tiers === 1) {
      return { ...electrical, spacingInfo: { ...manualSpacing,
        minimum_distance_m: pitch, pitch_m: pitch, row_vertical_modules: 1,
      } };
    }
  }
  return manualSpacing ? { ...electrical, spacingInfo: manualSpacing } : electrical;
}
